import "./App.css";

// import { redirect, useLoaderData } from "react-router";
import { useContext } from "react";
import { CookiesProvider } from "react-cookie";

import CookieContext from "./contexts/CookieContext";

import {
  Outlet,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import { CookieContextProvider } from "./contexts/CookieContext";
import { AppContextProvider } from "./contexts/AppContext";
import { ExpTimeContextProvider } from "./contexts/ExpTimeContext";

// 全体のcomponents
import Account from "./components/Account";
import Device from "./components/Device";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Outlet部分のcomponents
import NotFound from "./components/NotFound";
import Home from "./components/Home";
// import AutoRefresh from "./components/AutoRefresh";
import ActionState from "./components/ActionState";
import Optimistic from "./components/Optimistic";
import OptimisticUpdate from "./components/OptimisticUpdate";
import Iine from "./components/Iine";
import Chat from "./components/Chat";
// import WorkTimeTracker from "./components/WorkTimeTracker";
// import Item from "./components/Item";
import Checklist from "./components/Checklist";
import Checklist2 from "./components/Checklist2";
import Checklist3 from "./components/Checklist3";
// import Cookie from "./components/Cookie";
import List from "./components/List";
// import Roulette from "./components/Roulette";
// import React19 from "./components/React19";
// import Point from "./components/Point";
// import About from "./components/About";
// import Contact from "./components/Contact";
// import LinkCollection from "./components/LinkCollection";
import MyPage from "./components/MyPage";

// 全体のLayoutを設定
const Layout = () => {
  const { cookies } = useContext(CookieContext);

  return (
    <>
      <div className="bd-callout bd-callout-info">
        {/* <Account /> */}
        <Device />
      </div>
      <div className="bd-callout bd-callout-info">
        <Navbar />
      </div>
      <div className="bd-callout bd-callout-info">
        <Outlet />
      </div>
      <div className="bd-callout bd-callout-info">
        {/* <Footer /> */}
        {/* <Footer /> */}
      </div>
    </>
  );
};

// Layout内のOutletに表示する部分をcreateBrowserRouterで設定
function App() {
  const router = createBrowserRouter([
    {
      // LayoutでAccount、Navbar、Outlet、Footerを設定 */}
      path: "/",
      element: <Layout />,
      errorElement: <h2>ErrorPage</h2>,
      children: [
        {
          index: true,
          element: <Home />,
        },
        // {
        //   path: "autorefresh/*",
        //   element: <AutoRefresh />,
        // },
        {
          path: "actionstate/*",
          element: <ActionState />,
        },
        {
          path: "optimistic/*",
          element: <Optimistic />,
        },
        {
          path: "optimisticupdate/*",
          element: <OptimisticUpdate />,
        },
        {
          path: "iine/*",
          element: <Iine />,
        },
        {
          path: "chat/*",
          element: <Chat />,
        },
        // {
        //   path: "worktimetracker/*",
        //   element: <WorkTimeTracker />,
        // },
        // {
        //   path: "item/*",
        //   element: <Item />,
        // },
        {
          path: "checklist/*",
          element: <Checklist />,
        },
        {
          path: "checklist2/*",
          element: <Checklist2 />,
        },
        {
          path: "checklist3/*",
          element: <Checklist3 />,
        },
        // {
        //   path: "cookie/*",
        //   element: <Cookie />,
        // },
        {
          path: "list/*",
          element: <List />,
        },
        // {
        //   path: "roulette/*",
        //   element: <Roulette />,
        // },
        // {
        //   path: "react19/*",
        //   element: <React19 />,
        // },
        // {
        //   path: "point/*",
        //   element: <Point />,
        // },
        // {
        //   path: "about/*",
        //   element: <About />,
        // },
        // {
        //   path: "contact/*",
        //   element: <Contact />,
        // },
        // {
        //   path: "linkcollection/*",
        //   element: <LinkCollection />,
        // },
        {
          path: "MyPage/*",
          element: <MyPage />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
  ]);

  return (
    <div className="App">
      <CookiesProvider>
        <AppContextProvider>
          <CookieContextProvider>
            <ExpTimeContextProvider>
              <RouterProvider router={router} />
            </ExpTimeContextProvider>
          </CookieContextProvider>
        </AppContextProvider>
      </CookiesProvider>
    </div>
  );
}

export default App;
